import { ImageContentCardData } from "types/image-content-card-data";
import { RideFilter } from "types/filters";
import { getRidesForFilters } from "hooks/get-filtered-rides";
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkById } from "hooks/use-generate-site-link";

export const getImageContentCardsForRides = (
    linkLabel: string,
    RideFilters: RideFilter[],
    signatureEventId?: string
): ImageContentCardData[] => {
    const rides = getRidesForFilters(RideFilters, signatureEventId);

    if (rides.length > 0) {
        return rides.map((ride) => {
            const image = isGatsbyImageData(ride.heroImage?.carouselCardGatsbyImage)
                ? ride.heroImage?.carouselCardGatsbyImage
                : undefined;

            const buttonUrl = getLinkById(ride.id, signatureEventId) ?? "#";

            return {
                id: ride.id,
                cardImage: image,
                cardImageAlt: ride.heroImage?.alt ?? "",
                headline: ride.title ?? "",
                subtext: ride.shortDescription ?? "",
                buttonText: linkLabel,
                buttonUrl: buttonUrl,
            };
        });
    }

    return [];
};
